import { ChangeEventHandler, ReactNode, useRef } from "react";
// import { getInitials } from "../../../src/Custom hooks/helpers";
import styles from "./style.module.css";

interface Props {
  edit?: boolean;
  src?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  btnText: string;
  fallback?: string;
  accept?: string;
  children: ReactNode;
  altChildren?: ReactNode;
}

const FileTemp = ({
  edit,
  src,
  onChange,
  btnText,
  fallback,
  accept,
  children,
  altChildren,
}: Props) => {
  const imageRef = useRef<HTMLInputElement>(null);
  return (
    <div
      className={styles.container}
      onClick={() => imageRef.current && imageRef.current.click()}
    >
      {!src ? <>{children}</> : <>{altChildren && altChildren}</>}
      {!edit && (
        <>
          <input
            hidden
            ref={imageRef}
            type="file"
            accept={accept ? accept : "image/jpeg"}
            onChange={onChange}
          />
        </>
      )}
    </div>
  );
};

export default FileTemp;
